module.exports = __webpack_public_path__ + "img/1F1EB-1F1F4.d6a9dd07.svg";